"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ContactMethod;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _generic = _interopRequireDefault(require("../icons/generic"));
var _address = _interopRequireDefault(require("./address"));
var _utils = require("../../utils/utils");
require("../../utils/_variables.css");
// Components

// Utils

const {
  canHover
} = (0, _utils.getMediaQueries)();

// Styles

const Option = _styledComponents.default.a.withConfig({
  displayName: "contact-method__Option",
  componentId: "sc-y1440-0"
})(["align-items:center;display:flex;padding:8px 0;text-align:left;text-decoration:none;word-break:break-word;&:active,&:focus{color:var(--pacific-blue-hex);outline:none;svg{circle{fill:", ";stroke:", ";}path{fill:", ";stroke:", ";}}}svg{flex-shrink:0;margin-right:12px;circle{fill:", ";stroke:", ";transition:all 0.2s ease-in-out;}path{fill:", ";stroke:", ";transition:all 0.2s ease-in-out;}}&.icon-only{svg{margin-right:0;}}.text,*{color:", ";font-size:14px;letter-spacing:0.01em;line-height:18px;transition:all 0.2s ease-in-out;}", ""], props => props.$circleActiveColor || _utils.colors["pacific-blue-2"].hex, props => props.$borderActiveColor || _utils.colors["pacific-blue-2"].hex, props => props.$iconActiveColor || undefined, props => props.$iconBorderActiveColor || undefined, props => props.$circleDefaultColor || undefined, props => props.$borderDefaultColor || undefined, props => props.$iconDefaultColor || "transparent", props => props.$iconBorderDefaultColor || undefined, props => props.$textDefaultColor || _utils.colors["pilot-grey-7"].hex, canHover`
    :hover {
      text-decoration: none;
      svg {
        circle {
          fill: ${props => props.$circleActiveColor || _utils.colors["pacific-blue-2"].hex};
          stroke: ${props => props.$borderActiveColor || _utils.colors["pacific-blue-2"].hex};
        }
        path {
          fill: ${props => props.$iconActiveColor || "transparent"};
          stroke: ${props => props.$iconBorderActiveColor || undefined};
        }
      }
      .text, * {
        color: ${props => props.$textActiveColor || _utils.colors["pacific-blue"].hex};
      }
    }
  `);

// Main Component
function ContactMethod({
  contactInformation,
  address,
  type,
  icon,
  showText,
  circleDefaultColor,
  circleActiveColor,
  iconDefaultColor,
  iconActiveColor,
  borderDefaultColor,
  borderActiveColor,
  iconBorderActiveColor,
  iconBorderDefaultColor,
  textDefaultColor,
  textActiveColor,
  text
}) {
  const optionProps = {
    $circleDefaultColor: circleDefaultColor,
    $circleActiveColor: circleActiveColor,
    $iconDefaultColor: iconDefaultColor,
    $iconActiveColor: iconActiveColor,
    $borderDefaultColor: borderDefaultColor,
    $borderActiveColor: borderActiveColor,
    $iconBorderActiveColor: iconBorderActiveColor,
    $iconBorderDefaultColor: iconBorderDefaultColor,
    $showText: showText,
    $textDefaultColor: textDefaultColor,
    $textActiveColor: textActiveColor
  };
  switch (type) {
    default:
    case "calendar":
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Option, Object.assign({
        className: `contact-method ${showText ? "" : "icon-only"}`,
        href: contactInformation.calendly,
        target: "_blank",
        rel: "noreferrer"
      }, optionProps), icon || /*#__PURE__*/_react.default.createElement(_generic.default, {
        className: "contact-icon",
        icon: "calendar"
      }), showText && /*#__PURE__*/_react.default.createElement("span", {
        className: "text"
      }, text || "Schedule time on my calendar")));
    case "call":
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Option, Object.assign({
        className: `contact-method ${showText ? "" : "icon-only"}`,
        href: `tel:${(0, _utils.getPhoneNumbers)(contactInformation).primaryPhone}`
      }, optionProps), icon || /*#__PURE__*/_react.default.createElement(_generic.default, {
        className: "contact-icon",
        icon: "phone"
      }), showText && /*#__PURE__*/_react.default.createElement("span", {
        className: "text"
      }, text || (0, _utils.getPhoneNumbers)(contactInformation).primaryPhoneText)));
    case "directions":
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Option, Object.assign({
        href: encodeURI(`https://google.com/maps/place/${(0, _utils.getAddress)(address)}`),
        target: "_blank",
        rel: "noreferrer",
        className: `contact-method ${showText ? "" : "icon-only"}`
      }, optionProps), icon || /*#__PURE__*/_react.default.createElement(_generic.default, {
        className: "contact-icon",
        icon: "map-pin"
      }), showText && (text || /*#__PURE__*/_react.default.createElement(_address.default, {
        professional: address,
        streetBreak: !address && false || address && !(address !== null && address !== void 0 && address.suite) && true,
        streetComma: !address && true || address && (address === null || address === void 0 ? void 0 : address.suite) && true,
        cityComma: true,
        suiteBreak: true
      }))));
    case "mail":
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Option, Object.assign({
        href: `mailto:${contactInformation.email}`,
        className: `contact-method ${showText ? "" : "icon-only"}`
      }, optionProps), icon || /*#__PURE__*/_react.default.createElement(_generic.default, {
        className: "contact-icon",
        icon: "mail"
      }), showText && /*#__PURE__*/_react.default.createElement("span", {
        className: "text"
      }, text || contactInformation.email)));
    case "text":
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Option, Object.assign({
        className: `contact-method ${showText ? "" : "icon-only"}`,
        href: `sms:${(0, _utils.getPhoneNumbers)(contactInformation).mobilePhone}`
      }, optionProps), icon || /*#__PURE__*/_react.default.createElement(_generic.default, {
        className: "contact-icon",
        icon: "message-circle"
      }), showText && /*#__PURE__*/_react.default.createElement("span", {
        className: "text"
      }, text || (0, _utils.getPhoneNumbers)(contactInformation).mobilePhoneText)));
  }
}

// Prop Types
ContactMethod.propTypes = {
  /**
   * Object containing contact properties (e.g. officePhone)
   */
  contactInformation: _propTypes.default.shape(),
  /**
   * Object containing address properties (e.g. city, street)
   */
  address: _propTypes.default.shape(),
  /** Should text be shown or only the icon? */
  showText: _propTypes.default.bool,
  /**
   * Name of icon
   */
  icon: _propTypes.default.element,
  /**
   * Contact method (e.g. call, text)
   */
  type: _propTypes.default.string.isRequired,
  /**
   * Sets default color of icon circle
   */
  circleDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of icon circle
   */
  circleActiveColor: _propTypes.default.string,
  /**
   * Sets default color of icon
   */
  iconDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of icon
   */
  iconActiveColor: _propTypes.default.string,
  /**
   * Sets active color of icon border
   */
  iconBorderActiveColor: _propTypes.default.string,
  /**
   * Sets default color of icon border
   */
  iconBorderDefaultColor: _propTypes.default.string,
  /**
   * Sets default color of border around icon circle
   */
  borderDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of border around icon circle
   */
  borderActiveColor: _propTypes.default.string,
  /** Sets default color of text */
  textDefaultColor: _propTypes.default.string,
  /** Sets active color of text */
  textActiveColor: _propTypes.default.string,
  /** Text to display in link */
  text: _propTypes.default.string
};
ContactMethod.defaultProps = {
  showText: true
};
ContactMethod.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContactMethod",
  "props": {
    "showText": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Should text be shown or only the icon?",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "contactInformation": {
      "description": "Object containing contact properties (e.g. officePhone)",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "address": {
      "description": "Object containing address properties (e.g. city, street)",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "icon": {
      "description": "Name of icon",
      "type": {
        "name": "element"
      },
      "required": false
    },
    "type": {
      "description": "Contact method (e.g. call, text)",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "circleDefaultColor": {
      "description": "Sets default color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "circleActiveColor": {
      "description": "Sets active color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconDefaultColor": {
      "description": "Sets default color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconActiveColor": {
      "description": "Sets active color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconBorderActiveColor": {
      "description": "Sets active color of icon border",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconBorderDefaultColor": {
      "description": "Sets default color of icon border",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "borderDefaultColor": {
      "description": "Sets default color of border around icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "borderActiveColor": {
      "description": "Sets active color of border around icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "textDefaultColor": {
      "description": "Sets default color of text",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "textActiveColor": {
      "description": "Sets active color of text",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "text": {
      "description": "Text to display in link",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};